export default "__VITE_ASSET__cbb9c909__"